import type { UnwrapNestedRefs } from 'vue';
import type { MoviePlayerState } from 'src/models/moviePlayer';

interface MoviePlayerDownloadFlagsContext {
  onStartDownloadMovieFile: () => void;
  onFinishDownloadMovieFile: () => void;
  onStartDownloadScreenshot: () => void;
  onFinishDownloadScreenshot: () => void;
}

// isDownloading*フラグの切り替えのみを行う。実際のダウンロード処理は呼び出し元(BasicMoviePlayer)が持つ。
export function useMoviePlayerDownloadFlags(
  state: UnwrapNestedRefs<MoviePlayerState>,
): MoviePlayerDownloadFlagsContext {
  const onStartDownloadMovieFile = () => {
    state.ui.isDownloadingMovieFile = true;
  };
  const onFinishDownloadMovieFile = () => {
    state.ui.isDownloadingMovieFile = false;
  };
  const onStartDownloadScreenshot = () => {
    state.ui.isDownloadingScreenshot = true;
  };
  const onFinishDownloadScreenshot = () => {
    state.ui.isDownloadingScreenshot = false;
  };

  return {
    onStartDownloadMovieFile,
    onFinishDownloadMovieFile,
    onStartDownloadScreenshot,
    onFinishDownloadScreenshot,
  };
}
